import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { BaseResourceService } from '@kailona/core';
import mapFromFHIR from '../mappers/mapFromFHIR';
import { mapToFHIRGlucose } from '../mappers/mapToFHIR';

var DiabetesDataService = /*#__PURE__*/function (_BaseResourceService) {
  _inherits(DiabetesDataService, _BaseResourceService);

  var _super = _createSuper(DiabetesDataService);

  function DiabetesDataService() {
    var _this;

    _classCallCheck(this, DiabetesDataService);

    _this = _super.call(this, 'Observation');
    _this.glucoseSystemCodes = {
      blood: 'http://loinc.org|15074-8',
      // Laboratory
      capillaryBloodByGlucometer: 'http://loinc.org|14743-9',
      // Glucose Test Strip
      bodyFluid: 'http://loinc.org|14745-4' // Continuous Glucose Monitoring (CGM) Device

    };
    return _this;
  }

  _createClass(DiabetesDataService, [{
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(DiabetesDataService.prototype), "fetchData", this).call(this, [{
                  patient: "Patient/".concat(this.patientId),
                  code: Object.values(this.glucoseSystemCodes).join(',')
                }].concat(_toConsumableArray(params)));

              case 2:
                data = _context.sent;
                return _context.abrupt("return", mapFromFHIR(data));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "fetchNextData",
    value: function () {
      var _fetchNextData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _get(_getPrototypeOf(DiabetesDataService.prototype), "fetchNextData", this).call(this);

              case 2:
                data = _context2.sent;
                return _context2.abrupt("return", mapFromFHIR(data));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchNextData() {
        return _fetchNextData.apply(this, arguments);
      }

      return fetchNextData;
    }()
  }, {
    key: "upsertData",
    value: function () {
      var _upsertData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var idMap, bodyWeightObservationToUpsert;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                idMap = {}; // Body Weight

                bodyWeightObservationToUpsert = mapToFHIRGlucose(data);
                _context3.next = 4;
                return _get(_getPrototypeOf(DiabetesDataService.prototype), "upsertData", this).call(this, bodyWeightObservationToUpsert);

              case 4:
                idMap.glucose = _context3.sent;
                return _context3.abrupt("return", idMap);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsertData(_x2) {
        return _upsertData.apply(this, arguments);
      }

      return upsertData;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DiabetesDataService;
}(BaseResourceService);

export { DiabetesDataService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DiabetesDataService, "DiabetesDataService", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/services/DiabetesDataService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();